module.exports = __webpack_public_path__ + "img/cww_11.506c06a4.jpg";